import React from "react";
import { ChevronRight } from "react-bootstrap-icons";

interface ShareButtonProps {
  img: string;
  label: string;
  href: string;
}

function ShareButton({ img, label, href }: ShareButtonProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="share-btn d-flex align-items-center justify-content-between p-3 rounded-3 text-decoration-none"
    >
      <div className="d-flex align-items-center gap-3">
        <img src={img} width={20} height={20} alt={`${label} icon`} />
        <span className="text-dark fs-6">{label}</span>
      </div>
      <ChevronRight className="text-dark" size={20} />
    </a>
  );
}

export default ShareButton;
